// Alpine is now bundled with Livewire 3 - no manual import needed

require('../bootstrap');

window._ = require('lodash');
window.Swal = require('sweetalert2');

window.Popper = require('@popperjs/core').default;

const jQuery = require('jquery');
window.$ = window.jQuery = jQuery;


require('jquery-ui/dist/jquery-ui.js');
window.colorbox = require('jquery-colorbox');
//require("tinymce");

// CoreUI
require('@coreui/coreui');
require('@coreui/utils');

import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
window.ChartDataLabels = ChartDataLabels;
window.Chart = Chart;

window.select2 = require('select2');

require('leaflet/dist/leaflet.js');
require('leaflet-polylinedecorator/dist/leaflet.polylineDecorator.js');

// Boilerplate
require('../plugins');

require('../utils/standalonepopup.js');

window.Push = require('push.js/bin/push.min.js');
